import { render, staticRenderFns } from "./keyEnterprises.vue?vue&type=template&id=6645ce23&scoped=true&"
import script from "./keyEnterprises.vue?vue&type=script&lang=js&"
export * from "./keyEnterprises.vue?vue&type=script&lang=js&"
import style0 from "./keyEnterprises.vue?vue&type=style&index=0&id=6645ce23&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6645ce23",
  null
  
)

export default component.exports